import React from 'react';
import RatingStars from 'react-rating-stars-component';

const StarRatings = ({ rating,size }) => {
  return <RatingStars activeColor="#DFB300" size={size} count={5} isHalf={true} value={rating} edit={false} />;
};

export default StarRatings;
